import api from '../api'
export default {
	namespaced: true,
	state: {
		dictList: [],
		dictTypeList: [],
		dictTotal: ''
	},
	mutations: {
		GET_DICT_LIST( state, data = {} ) {
			state.dictList = data.records
			state.dictTotal = data.total
		},
		GET_DICTTYPE_LIST( state, data = {} ) {
			state.dictTypeList = data
		}
	},
	actions: {
		GET_DICT_LIST( { commit, dispatch },  config ) {
			return api.getDictList( config ).then(( res ) => {
				commit( 'GET_DICT_LIST', res.payload )
				return res
			}).catch(( rej ) => {
				window.myVue.$message.error( rej.message )
			})
		},
		GET_DICTTYPE_LIST( { commit, dispatch }, config ) {
			return api.getDictTypeList( config ).then( ( res ) => {
				let list = res.payload
				let dictTypeList = []
				list.forEach(( item, index ) => {
					let key = Object.keys( item )[ 0 ]
					let value = Object.values( item )[ 0 ]
					dictTypeList.push({
						name: value,
						value: key
					})
				})
				commit( 'GET_DICTTYPE_LIST', dictTypeList )
				return res
			}).catch(( rej ) => {
				window.myVue.$message.error( rej.message )
			})
		},
		GET_DICT_DETAIL ({ commit, dispatch }, config) {
			return api.dictDetail(config).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		},
		DELETE_DICT ({ commit, dispatch }, params) {
			return api.deletedict({
				params: params
			}).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		},
		ADD_DICT ({ commit, dispatch }, config) {
			return api.adddict(config).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		},
		UPDATE_DICT ({ commit, dispatch }, config) {
			return api.updatedict(config).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/dictManage/store/index.js